import React from 'react';
import moment from 'moment';

import styles from './compensationSubmissionDraftsStyles.scss';

import Link from 'buyside/components/presentation/Link/link';

import { userCompensationsUrl, compensationEditUrl } from 'buyside/util/urlHelper';

const CompensationSubmissionDrafts = ({ currentUser, destroyCompensation }) => {
  const { draftCompensations } = currentUser;
  const actualCompDrafts = draftCompensations.filter(draft => draft.category === 'actual');
  const goToUserCompensations = () => window.location.assign(userCompensationsUrl());

  return (
    <div className={styles.draftContainer}>
      <div>
        <strong>Note:</strong> You currently have{' '}
        <strong>
          {actualCompDrafts.length} {actualCompDrafts.length > 1 ? 'sets' : 'set'} of compensation
          draft
        </strong>
        . Select below to continue editing.
      </div>
      <table className={styles.draftsTable}>
        <tbody>
          {actualCompDrafts.map(draft => (
            <tr key={draft.id} className={styles.draftComp}>
              <td className={styles.draftLink}>
                <Link to={compensationEditUrl(draft.id)}>
                  {`${draft.year} actual - ${draft.year + 1} estimated`} compensation
                </Link>
              </td>
              <td>{moment(draft.updatedAt).fromNow()}</td>
              <td>
                <button
                  onClick={() => {
                    const estimateCompDraft = draftCompensations.filter(
                      estimate =>
                        estimate.category === 'estimated' && estimate.year === draft.year + 1
                    );
                    if (estimateCompDraft.length > 0) destroyCompensation(estimateCompDraft[0].id);
                    destroyCompensation(draft.id).then(goToUserCompensations());
                  }}
                  className={styles.deleteDraftButton}
                >
                  x Delete Draft
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CompensationSubmissionDrafts;
